// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3wST6","left":"InfoRow_left__3FCoN"};